import { AdminActions } from "../actions";
import * as Actions from "../actions";
import { AdminState } from "../state";

const initialState: AdminState = {
    error: {}
};

/**
 * Only the app transfer (the REST call AppTransferAppDialog makes) still goes through redux; its
 * error is kept so the dialog can stay open and say what went wrong, and cleared when the next
 * transfer starts. Every other action returns the state untouched.
 */
export function adminReducer(state: AdminState = initialState, action: AdminActions): AdminState {
    switch (action.type) {
        case Actions.TRANSFER_APP:
            // A new attempt must not inherit the last one's failure.
            return { ...state, error: { ...state.error, [Actions.TRANSFER_APP_END]: undefined } };
        case Actions.TRANSFER_APP_END:
            return { ...state, error: { ...state.error, [action.type]: action.payload.error } };
        default:
            return state;
    }
}
